





































import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class FallbackSelfies extends Vue {
  @Prop()
  near!: string;
  @Prop()
  far!: string;

  isFarSelected = true;
  toggleFarSelfie() {
    this.isFarSelected = true;
  }
  toggleNearSelfie() {
    this.isFarSelected = false;
  }
}
